import { render, staticRenderFns } from "./DetailsShopInfo.vue?vue&type=template&id=29972dae&scoped=true&"
import script from "./DetailsShopInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsShopInfo.vue?vue&type=style&index=0&id=29972dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29972dae",
  null
  
)

export default component.exports